export enum MissionType {
  Unknown = 0,
  Sales = 1,
  Technical = 2,
  Installation = 3,
  Inspection = 4,
  CustomerSupport = 5,
  Maintenance = 6,
  ProjectManagement = 98,
  Other = 99,
}
